// extracted by mini-css-extract-plugin
export default {"grayedOutRow":"UsersAccessTable_grayedOutRow__QwMpd"};